import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getListModule,
  getListModuleSupport,
  getListCourse,
} from "../../../../../../../../api/repositories";
import { setInvalidToken } from "../../../../../../../../redux/features/main/invalidTokenSlice";

const useActions = (
  loadingLP,
  journeyId,
  courseId,
  setListModule,
  setListModuleSupport,
  setLoadingLM,
  mainState,
  reFetchLeftSection,
  setRefetchLeftSection,
  setPercentCompleteCourse,
  isMobileVersion,
) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [currCourse, setCourse] = useState({});

  const url = window.location.pathname;
  const arrId = url.split("/");
  const courseIdPosition = arrId.indexOf("course");
  const currentCourseId = parseInt(arrId[courseIdPosition + 1]);

  const fetchDetailCourse = async () => {
    setLoading(true);
    setLoadingLM(true);

    try {
      const { data, status } = await getListModule(journeyId, currentCourseId);
      dispatch(setInvalidToken(status));
      console.log("data", data);
      setCourse(data);
      setListModule(data);
      mainState.setLastModule(data);
    } catch (err) {
      setCourse(null);
      setListModule(null);
      // setLoadingLM(false);
    } finally {
      fetchSupportingModule();
    }
  };

  const fetchSupportingModule = async () => {
    try {
      const { data, status } = await getListModuleSupport(
        journeyId,
        currentCourseId,
      );
      dispatch(setInvalidToken(status));
      setListModuleSupport(data);
      mainState.setLastModuleSupport(data);
    } catch (err) {
      setListModuleSupport(null);
      // setLoadingLM(false);
    } finally {
      setLoading(false);
      setLoadingLM(false);
      mainState.setDefaultKeyListCourse(null);
    }
  };

  // only to get percentage Course completed and Modules Completed
  const reFetchDetailJourney = async () => {
    const url = window.location.pathname;
    const arrId = url.split("/");
    const journeyIdPosition = arrId.indexOf("journey");
    const currentId = parseInt(arrId[journeyIdPosition + 1]);
    // if (isMobileVersion) {
    //   setLoadingLM(true);
    // }

    try {
      const { data, status } = await getListCourse(currentId);
      dispatch(setInvalidToken(status));
      countPercentageCourses(data.courses);
      countEssentialCompleted(data.courses);
    } catch (err) {
    } finally {
      if (reFetchLeftSection === true) setRefetchLeftSection(false);
    }
  };

  const countPercentageCourses = (data) => {
    let completeCourse = 0;
    data.map((v) => {
      if (v.is_completed == 1) {
        completeCourse++;
      }
    });
    const percent =
      data.length > 0 ? Math.round((completeCourse / data.length) * 100) : 0;
    setPercentCompleteCourse(percent);
  };

  const countEssentialCompleted = (data) => {
    document.querySelectorAll(".amount-module-completed").forEach((e, idx) => {
      e.innerHTML = data[idx].total_completed;
    });
  };

  useEffect(() => {
    if (isMobileVersion && loadingLP === false) {
      fetchDetailCourse();
    } else if (loadingLP === false && mainState.defaultKeyListCourse !== null) {
      fetchDetailCourse();
    }
  }, [loadingLP, courseId, currentCourseId]);

  useEffect(() => {
    if (mainState.reFetchJourney === true) reFetchDetailJourney();
  }, [mainState]);

  return {
    currCourse,
  };
};

export default useActions;
